<template>
  <span>
    <!-- <a-input :value="selectedNames" placeholder="点击选择门店" style="width: 180px" @click="handlerOpen">
      <a-icon slot="suffix" type="search" @click="handlerOpen" />
    </a-input> -->
    <a-button type="link" @click.stop="handlerOpen">门店多选</a-button>
    <!-- 树形选项 -->
    <a-modal v-model="showStateMsgDialog" :title="title ? title : '门店名称选择'" :maskClosable="false" :closable="true" :keyboard="false">
      <template slot="footer">
        <a-button key="submit" @click="handlerSubmit()">确认</a-button>
        <a-button key="back" @click="handlerClose()">关闭</a-button>
      </template>
      <div class="tree-list">
        <div class="tree-label">
          <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
          <!-- <a @click="isFilter = !isFilter">{{isFilter ? '不过滤' : '过滤'}}</a> -->
        </div>
        <div v-if="(isFilter && area.hasVendors) || !isFilter" v-for="(area, i) in computedData" :key="i">
          <div class="tree-label" :class="area.indeterminate || area.checkAll ? 'checked' : ''">
            <a-icon @click="()=>{toggleOpen(i)}" v-if="area.open" type="caret-down" />
            <a-icon @click="()=>{toggleOpen(i)}" v-else type="caret-right" />
            <a-checkbox :indeterminate="area.indeterminate" :checked="area.checkAll" @change.stop="(e)=>{onCheckAreaChange(e, i)}">{{ area.name }}</a-checkbox>
          </div>
          <div v-show="area.open" class="tree-list">
            <div v-if="(isFilter &&range.hasVendors) || !isFilter" v-for="(range, j) in area.ranges" :key="j">
              <div class="tree-label" :class="range.indeterminate || range.checkAll ? 'checked' : ''">
                <!-- <a-icon @click="()=>{toggleOpen(i, j)}" v-if="range.open" type="caret-down" /> -->
                <!-- <a-icon @click="()=>{toggleOpen(i, j)}" v-else type="caret-right" /> -->
                <a-checkbox :indeterminate="range.indeterminate" :checked="range.checkAll" @change.stop="(e)=>{onCheckRangeChange(e, i, j)}">{{ range.name }}</a-checkbox>
              </div>
              <div v-show="range.open" class="tree-list">
                <div v-for="(vendor, k) in range.vendors" :key="k">
                  <div class="tree-label">
                    <a-checkbox :checked="vendor.checked" @change.stop="(e)=>{changeVendor(e, i, j, k)}">{{ vendor.name }}</a-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </span>
</template>

<script>
  export default {
    props: {
      treeData: {
        type: Array,
        required: true,
      },
      value: {
        type: Array,
        default: []
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        data: [],
        selectedNames: '',
        showStateMsgDialog: false,
        indeterminate: false,
        checkAll: false,
        isFilter: true, // 是否过滤空值
      }
    },
    watch: {
      showStateMsgDialog(newVal) {
        if(newVal) {
          this.data = [].concat(this.data.map(area=> {
            let indeterminate = false;
            area.ranges = [].concat(area.ranges.map(range => {
              range.vendors = [].concat(range.vendors.map(vendor => {
                for(let i = 0; i < this.value.length; i++) {
                  if(vendor.id == this.value[i]) {
                    indeterminate = true;
                    break;
                  }
                }
                return vendor;
              }));
              if(indeterminate) {
                range.open = true;
              }
              return range;
            }));
            if(indeterminate) {
              area.open = true;
            }
            return area;
          }));
        }
      },
      treeData: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.data = [].concat(newVal.map(area => {
              area.open = false;
              area.ranges = [].concat(area.ranges.map(range => {
                range.open = true;
                range.vendors = [].concat(range.vendors.map(vendor => {
                  return vendor;
                }))
                return range;
              }))
              return area
            }));
            this.getSelectedNames();
          }
        },
        deep: false
      },
      value: {
        handler(newVal, oldVal) {
          if(newVal) {
            this.getSelectedNames();
          }
        },
        deep: false
      }
    },
    computed: {
      tempSelected() {
        let list = [];
        this.data.map(area => {
          area.ranges = [].concat(area.ranges.map(range => {
            range.vendors = [].concat(range.vendors.map(vendor => {
              if(vendor.checked) {
                list.push(vendor.id);
              }
              return vendor;
            }));
            return range;
          }));
          return area;
        });
        return list;
      },
      computedData() {
        this.indeterminate = false; //
        let vendors = 0;
        let checkedVendors = 0;
        let data = this.data.map(area => {
          area.hasVendors = false;
          let areaLen = 0;
          area.indeterminate = false;
          area.ranges = [].concat(area.ranges.map(range => {
            if(range.vendors && range.vendors.length > 0) {
              area.hasVendors = true;
              range.hasVendors = true;
            } else {
              range.hasVendors = false;
            }
            let rangeLen = 0;
            range.indeterminate = false;
            range.vendors = [].concat(range.vendors.map(vendor => {
              vendors += 1;
              if(vendor.checked) {
                rangeLen += 1;
                checkedVendors += 1;
                this.indeterminate = true;
                area.indeterminate = true;
                range.indeterminate = true;
              }
              return vendor;
            }));
            range.checkAll = rangeLen === range.vendors.length;
            if(range.checkAll) {
              range.indeterminate = false;
              areaLen += 1;
            }
            return range;
          }));
          area.checkAll = areaLen === area.ranges.length;
          if(area.checkAll) {
            area.indeterminate = false;
          }
          return area;
        });
        console.log(checkedVendors, vendors)
        this.checkAll = checkedVendors === vendors;
        if(this.checkAll) {
          this.indeterminate = false;
        }
        return data;
      }
    },
    mounted() {},
    methods: {
      getSelectedNames() {
        let list = [];
        this.data = this.data.map(area => {
          area.open = false;
          area.ranges = [].concat(area.ranges.map(range => {
            range.open = true;
            range.vendors = [].concat(range.vendors.map(vendor => {
              vendor.checked = false;
              for(let i = 0; i < this.value.length; i++) {
                if(this.value[i] == vendor.id) {
                  vendor.checked = true;
                  list.push(vendor.name);
                  break;
                }
              }
              return vendor;
            }))
            return range;
          }))
          return area
        });
        this.selectedNames = list.join('，');
      },
      onCheckAreaChange(e, i1) {
        let checked = e.target.checked;
        Object.assign(this, {
          data: this.data.map((area, i) => {
            if(i1 === i) {
              area.ranges = [].concat(area.ranges.map((range, j) => {
                range.vendors = [].concat(range.vendors.map((vendor, k) => {
                  vendor.checked = checked;
                  return vendor;
                }));
                return range;
              }));
            }
            return area;
          }),
        });
      },
      onCheckRangeChange(e, i1, j1){
        let checked = e.target.checked;
        Object.assign(this, {
          data: this.data.map((area, i) => {
            if(i1 === i) {
              area.ranges = [].concat(area.ranges.map((range, j) => {
                if(j1 === j) {
                  range.vendors = [].concat(range.vendors.map((vendor, k) => {
                    vendor.checked = checked;
                    return vendor;
                  }));
                }
                return range;
              }));
            }
            return area;
          }),
        });
      },
      changeVendor(e, i, j, k) {
        // console.log(e, i, j, k);
        let checked = e.target.checked;
        this.data[i].ranges[j].vendors[k].checked = checked;
        this.data = [].concat(this.data);
      },
      onCheckAllChange(e) {
        let checked = e.target.checked;
        Object.assign(this, {
          data: this.data.map((area, i) => {
            area.ranges = [].concat(area.ranges.map((range, j) => {
              range.vendors = [].concat(range.vendors.map((vendor, k) => {
                vendor.checked = checked;
                return vendor;
              }));
              return range;
            }));
            return area;
          }),
        });
      },
      onSelect(val) {
        console.log(val);
      },
      handlerSubmit(){
        this.$emit('input', this.tempSelected);
        this.$emit('change', this.tempSelected);
        this.showStateMsgDialog = false;
      },
      handlerOpen(){
        console.log('handlerOpen()');
        this.showStateMsgDialog = true;
      },
      handlerClose() {
        this.$emit('input', [...this.value]);
        this.showStateMsgDialog = false;
      },
      onVendorCheckChange(i, j, val) {
        console.log(i, j, val);
      },
      toggleOpen(i, j) {
        console.log('toggleOpen', i, j)
        if (j >= 0) {
          if(this.data[i].ranges[j].vendors.length > 0) {
            this.data[i].ranges[j].open = !this.data[i].ranges[j].open;
          } else {
            this.data[i].ranges[j].open = true;
          }
        } else if (i >= 0) {
          if(this.data[i].ranges.length > 0) {
            this.data[i].open = !this.data[i].open;
          } else {
            this.data[i].open = true;
          }
        }
        this.data = [].concat(this.data);
      },
    }
  }
</script>

<style scoped lang="less">
  .tree-label {
    cursor: pointer;
    &.checked {
      color: #1890ff !important;
    }
  }

  .tree-list {
    padding-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FormItemVendorTreeSelect.vue